import React, { Component } from "react";
import { Link } from "react-router-dom";
import { theme } from "../../assets/theme/theme";

class TrainingRequestList extends Component {
  constructor(props) {
    super(props);

    this.state = {
      activeTab: "All",
    };
  }

  renderCard(label, value, bgColor) {
    return (
      <div style={{ background: bgColor, border: "1px solid #E5E7EB", borderRadius: 12, padding: 18, minHeight: 105 }}>
        <div style={{ fontSize: 12, color: "#334155", fontWeight: 700 }}>{label}</div>
        <div style={{ fontSize: 28, fontWeight: 800, color: "#0F172A", marginTop: 10 }}>{value}</div>
        <div style={{ fontSize: 12, color: "#64748B", marginTop: 4 }}>Requests</div>
      </div>
    );
  }

  renderStatus(status) {
    const map = {
      "Pending Approval": { bg: "#FFF7E6", color: "#B76E00" },
      Draft: { bg: "#F1F5F9", color: "#475569" },
      Approved: { bg: "#ECFDF3", color: "#027A48" },
      Completed: { bg: "#EAF8FB", color: "#027A7A" },
      Rejected: { bg: "#FEECEC", color: "#B42318" },
      Withdrawn: { bg: "#F1F5F9", color: "#475569" },
    };

    const s = map[status] || map.Draft;

    return (
      <span style={{ background: s.bg, color: s.color, padding: "5px 10px", borderRadius: 8, fontSize: 12, fontWeight: 800 }}>
        {status}
      </span>
    );
  }

  render() {
    const rows = [
      ["TRN-2025-0012", "Digital Marketing Masterclass", "AIM Academy", "External", "15 Jun 2025", "17 Jun 2025", "1,800.00", "Pending Approval"],
      ["TRN-2025-0011", "Finance for Non-Finance", "BEC Learning", "External", "10 May 2025", "10 May 2025", "950.00", "Draft"],
      ["TRN-2025-0010", "Event Management 101", "MyCEB", "External", "02 Apr 2025", "04 Apr 2025", "2,300.00", "Approved"],
      ["TRN-2025-0009", "Leadership Development", "IPMA", "External", "20 Mar 2025", "21 Mar 2025", "1,500.00", "Completed"],
      ["TRN-2025-0008", "Excel Advanced", "ExcelPro", "External", "05 Feb 2025", "05 Feb 2025", "650.00", "Rejected"],
      ["TRN-2025-0007", "Procurement Governance", "Internal HR", "Internal", "12 Jan 2025", "12 Jan 2025", "0.00", "Withdrawn"],
    ];

    const filteredRows =
      this.state.activeTab === "All"
        ? rows
        : rows.filter((row) => row[7] === this.state.activeTab);

    return (
      <div style={{ padding: 24 }}>
        <div style={{ display: "flex", justifyContent: "space-between", marginBottom: 24 }}>
          <div>
            <h4 style={{ margin: 0, fontWeight: 800, color: "#0F172A" }}>Training Request</h4>
            <p style={{ margin: "6px 0 0", color: "#64748B", fontSize: 13 }}>
              Submit and track training requests, view status, approvals and related training records.
            </p>
          </div>

          <Link
            to="/training/request/create"
            style={{
              background: theme.colors.brand.primary || "#002B5B",
              color: "#fff",
              padding: "10px 16px",
              borderRadius: 8,
              textDecoration: "none",
              fontWeight: 800,
              fontSize: 13,
              height: 40,
            }}
          >
            + New Training Request
          </Link>
        </div>

        <div style={{ display: "grid", gridTemplateColumns: "repeat(6, minmax(0, 1fr))", gap: 14, marginBottom: 24 }}>
          {this.renderCard("My Requests", 12, "#EEF4FF")}
          {this.renderCard("Draft", 3, "#F8FAFC")}
          {this.renderCard("Pending Approval", 4, "#FFF7E6")}
          {this.renderCard("Approved", 4, "#ECFDF3")}
          {this.renderCard("Completed", 8, "#EAF8FB")}
          {this.renderCard("Rejected", 1, "#FEECEC")}
        </div>

        <div style={{ background: "#fff", border: "1px solid #E5E7EB", borderRadius: 12, overflow: "hidden" }}>
          <div style={{ display: "flex", gap: 24, padding: "16px 18px", borderBottom: "1px solid #E5E7EB", overflowX: "auto" }}>
            {["All", "Draft", "Pending Approval", "Approved", "Completed", "Rejected", "Withdrawn"].map((tab) => (
              <button
                key={tab}
                onClick={() => this.setState({ activeTab: tab })}
                style={{
                  border: 0,
                  background: "transparent",
                  fontWeight: 800,
                  fontSize: 13,
                  color: this.state.activeTab === tab ? theme.colors.brand.primary || "#002B5B" : "#64748B",
                  cursor: "pointer",
                  whiteSpace: "nowrap",
                  paddingBottom: 8,
                  borderBottom:
                    this.state.activeTab === tab
                      ? `2px solid ${theme.colors.brand.primary || "#002B5B"}`
                      : "2px solid transparent",
                }}
              >
                {tab}
              </button>
            ))}
          </div>

          <div style={{ display: "grid", gridTemplateColumns: "2fr 1fr 1fr 1fr 1fr auto", gap: 12, padding: 16 }}>
            <input placeholder="Search by request ID, course or provider..." style={inputStyle} />
            <select style={inputStyle}><option>Status</option></select>
            <select style={inputStyle}><option>Department</option></select>
            <select style={inputStyle}><option>Training Type</option></select>
            <input placeholder="Select date range" style={inputStyle} />
            <button style={secondaryButton}>Filters</button>
          </div>

          <div style={{ overflowX: "auto" }}>
            <table style={{ width: "100%", borderCollapse: "collapse" }}>
              <thead>
                <tr style={{ background: "#F8FAFC", color: "#475569", fontSize: 12 }}>
                  {["Request ID", "Course / Program", "Provider", "Training Type", "Start Date", "End Date", "Estimated Cost (RM)", "Status", "Action"].map((h) => (
                    <th key={h} style={thStyle}>{h}</th>
                  ))}
                </tr>
              </thead>

              <tbody>
                {filteredRows.map((row) => (
                  <tr key={row[0]} style={{ borderTop: "1px solid #E5E7EB" }}>
                    <td style={tdStyle}>
                      <Link
                        to={`/training/request/${row[0]}`}
                        style={{
                          color: theme.colors.brand.primary || "#002B5B",
                          fontWeight: 800,
                          textDecoration: "none",
                        }}
                      >
                        {row[0]}
                      </Link>
                    </td>
                    <td style={tdStyle}>{row[1]}</td>
                    <td style={tdStyle}>{row[2]}</td>
                    <td style={tdStyle}>{row[3]}</td>
                    <td style={tdStyle}>{row[4]}</td>
                    <td style={tdStyle}>{row[5]}</td>
                    <td style={tdStyle}>{row[6]}</td>
                    <td style={tdStyle}>{this.renderStatus(row[7])}</td>
                    <td style={tdStyle}>
                      <button style={actionButton}>⋮</button>
                    </td>
                  </tr>
                ))}

                {filteredRows.length === 0 && (
                  <tr>
                    <td colSpan="9" style={{ padding: 30, textAlign: "center", color: "#64748B" }}>
                      No records found for {this.state.activeTab}.
                    </td>
                  </tr>
                )}
              </tbody>
            </table>
          </div>

          <div style={{ padding: 16, color: "#64748B", fontSize: 12 }}>
            Showing {filteredRows.length === 0 ? 0 : 1} to {filteredRows.length} of {filteredRows.length} entries
          </div>
        </div>
      </div>
    );
  }
}

const inputStyle = {
  height: 38,
  border: "1px solid #E5E7EB",
  borderRadius: 8,
  padding: "0 12px",
  fontSize: 13,
  outline: "none",
};

const thStyle = {
  padding: "12px 14px",
  textAlign: "left",
  fontWeight: 800,
  whiteSpace: "nowrap",
};

const tdStyle = {
  padding: "14px",
  fontSize: 13,
  color: "#334155",
  verticalAlign: "middle",
  whiteSpace: "nowrap",
};

const secondaryButton = {
  background: "#fff",
  color: "#334155",
  border: "1px solid #CBD5E1",
  borderRadius: 8,
  padding: "9px 14px",
  fontWeight: 800,
  cursor: "pointer",
};

const actionButton = {
  border: "1px solid #CBD5E1",
  background: "#fff",
  borderRadius: 6,
  width: 30,
  height: 30,
  cursor: "pointer",
};

export default TrainingRequestList;